import { render, staticRenderFns } from "./fa-ruler.vue?vue&type=template&id=8d0ad5ae&"
import script from "./fa-ruler.vue?vue&type=script&lang=js&"
export * from "./fa-ruler.vue?vue&type=script&lang=js&"
import style0 from "./fa-ruler.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports